export var EVENT_KEYS = {
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    SPACE: 'SpaceBar',
    ARROW_UP: 'ArrowUp',
    ARROW_DOWN: 'ArrowDown',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_RIGHT: 'ArrowRight',
    TAB: 'Tab',
};
//# sourceMappingURL=event-keys.js.map